import { useQuery } from "react-query-v4";
import ResourcesAPI from "../ResourcesAPI";

export const useAllResources = (teamId, config = {}) => {
  return useQuery({
    queryKey: ["get-all-resources", teamId],
    queryFn: () => ResourcesAPI.getAllResources(teamId),
    staleTime: 1000 * 60 * 5,
    retry: 1,
    refetchOnWindowFocus: false,
    enabled: !!teamId,
    ...config,
  });
};

export const useIsAdminDepartment = (selectedResource, user, config = {}) => {
  return useQuery({
    queryKey: ["get-admin-department", selectedResource?.key],
    queryFn: () => ResourcesAPI.getIsAdminDepartment(selectedResource, user),
    staleTime: 1000 * 5,
    retry: 1,
    refetchOnWindowFocus: false,
    ...config,
  });
};

export const useAdminSelectedResource = (selectedResource, config = {}) => {
  return useQuery({
    queryKey: ["get-admin-resource", selectedResource?.key],
    queryFn: () => ResourcesAPI.getAdminSelectedResource(selectedResource),
    staleTime: 1000 * 5,
    retry: 1,
    refetchOnWindowFocus: false,
    ...config,
  });
};

export const useNonadminSelectedResource = (selectedResource, config = {}) => {
  return useQuery({
    queryKey: ["get-nonadmin-resource", selectedResource?.key],
    queryFn: () => ResourcesAPI.getNonadminSelectedResource(selectedResource),
    staleTime: 1000 * 5,
    retry: 1,
    refetchOnWindowFocus: false,
    ...config,
  });
};
